import React from "react";
import { FAQ_ITEMS } from "@/data/cabanas";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
    return (
        <div className="bg-cdb-cream min-h-[70vh]">
            <section className="pt-20 pb-12 sm:pt-28 sm:pb-16 leaf-pattern">
                <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
                    <span className="text-cdb-gold text-sm font-bold uppercase tracking-widest">
                        Dúvidas
                    </span>
                    <h1
                        data-testid="faq-title"
                        className="text-4xl sm:text-5xl lg:text-6xl font-bold text-cdb-forest mt-3 mb-4 leading-tight"
                    >
                        Perguntas frequentes
                    </h1>
                    <p className="text-cdb-earth/80 text-base sm:text-lg leading-relaxed">
                        Reunimos as principais dúvidas dos nossos hóspedes para ajudar você a planejar a sua estadia.
                    </p>
                </div>
            </section>

            <section className="pb-24 sm:pb-32">
                <div className="max-w-3xl mx-auto px-6 lg:px-8">
                    <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
                        {FAQ_ITEMS.map((item, i) => (
                            <AccordionItem
                                value={`item-${i}`}
                                key={i}
                                data-testid={`faq-item-${i}`}
                                className="bg-white border border-cdb-sand rounded-2xl px-5 sm:px-6"
                            >
                                <AccordionTrigger className="text-left text-base sm:text-lg font-bold text-cdb-forest hover:no-underline">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-cdb-earth leading-relaxed">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </section>
        </div>
    );
}
